// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"ActAsRetailerButton_buttonWrapper__2bBKy","buttonLabel":"ActAsRetailerButton_buttonLabel__1sC2R"};